/* @flow */

import React from 'react';
import Relay from 'react-relay';
import Helmet from 'react-helmet';

import NestedStatus from 'depop/components/NestedStatus';

import NotificationsProvider from 'depop/components/NotificationsProvider';

import { injectIntl, defineMessages } from 'react-intl';

import applyRootStyles from 'depop/utils/applyRootStyles';
import initImageAssets from 'depop/utils/initImageAssets';
import { currentUserFragment } from 'depop/getCurrentUser';

import Shell from 'depop/components/layout/Shell';

const NAME = 'Depop';
const IOS_ID = '518684914';
const ANDROID_ID = 'com.depop';
const TWITTER_ID = '380944344';
const FB_APP_ID = '127876583993492';

applyRootStyles();

const messages = defineMessages({
  description: {
    id: 'Application.defaultDescription',
    defaultMessage: 'Depop is where the world\'s creatives come to buy, sell and discover the most inspiring and unique things.',
    description: 'Default description for meta tags, Twitter cards and other third party magic.',
  },
  title: {
    id: 'Application.defaultTitle',
    defaultMessage: 'Depop - The creative community\'s mobile marketplace',
    description: 'Page title used from browser, social embed and search engines.'
  }
});

class Application extends React.PureComponent {
  props: {
    children: Object,
    hideFooter: boolean,
    hideAppBanner: boolean,
    hideHeader: boolean,
    hideCookieBanner: boolean,
    viewer: Object,
    intl: Object,
  };

  render() {
    const { children, viewer, hideFooter, hideHeader, hideAppBanner, hideCookieBanner, intl } = this.props;

    return (
      <NotificationsProvider>
        <div>
          <NestedStatus code={200} />
          <Helmet
            titleTemplate="%s - Depop"
            defaultTitle={intl.formatMessage(messages.title)}
            htmlAttributes={{ lang: intl.locale }}
            link={[
              {
                rel: 'canonical',
                href: 'https://www.depop.com/'
              }
            ]}
            meta={[
              { name: 'charset',                     content: 'utf-8' },
              { name: 'description',                 content: intl.formatMessage(messages.description) },
              { name: 'viewport',                    content: 'width=device-width, initial-scale=1' },
              { name: 'twitter:card',                content: 'app' },
              { name: 'twitter:site',                content: '@depop' },
              { name: 'twitter:creator:id',          content: TWITTER_ID },
              { name: 'twitter:description',         content: intl.formatMessage(messages.description) },
              { name: 'twitter:app:id:iphone',       content: IOS_ID },
              { name: 'twitter:app:id:ipad',         content: IOS_ID },
              { name: 'twitter:app:id:googleplay',   content: ANDROID_ID },
              { name: 'twitter:app:name:iphone',     content: NAME },
              { name: 'twitter:app:name:ipad',       content: NAME },
              { name: 'twitter:app:name:googleplay', content: NAME },
              { name: 'twitter:app:url:iphone',      content: 'depop://' },
              { name: 'twitter:app:url:ipad',        content: 'depop://' },
              { name: 'twitter:app:url:googleplay',  content: `https://play.google.com/store/apps/details?id=${ANDROID_ID}`, },
              { property: 'fb:app_id',               content: FB_APP_ID },
              { property: 'og:title',                content: intl.formatMessage(messages.title) },
              { property: 'og:description',          content: intl.formatMessage(messages.description) },
              { property: 'og:url',                  content: 'https://www.depop.com' },
            ]}
          />
          <Shell viewer={viewer} hideHeader={hideHeader} hideFooter={hideFooter} hideAppBanner={hideAppBanner} hideCookieBanner={hideCookieBanner}>{children}</Shell>
        </div>
      </NotificationsProvider>
    );
  }
}

export default Relay.createContainer(injectIntl(Application), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${currentUserFragment}
        ${Shell.getFragment('viewer')}
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/Application.js